import { Config } from "../config/config";
import { ComponentHelper } from "../util/componentHelper";
import { Helper } from "../util/helper";
import { HTTPService, JsonResultClass } from "../util/httpManager";
import { NotificationHelper } from "../util/notificationHelper";
import { DropDownList } from "./dropDownList"
import { Button, ButtonProps } from "./button"
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { BaseComponentProps, BaseField } from "./baseComponentProps";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export default class FlagSelection extends React.Component<FlagSelectionProps, FlagSelectionState>{
    private dataSource: Flag[];
    private translations: StringKeyDictionary<string>;
    private factory = ComponentHelper.createFactory();
    private canCreate: boolean = false;
    private canOpen: boolean = false;
    private initialId: string;
    constructor(props: FlagSelectionProps) {
        super(props)
        this.state = {
            value: props.value
        }
        if (Config.settings.flagsAreActive)
            this.initApp();
    }

    private initApp = async () => {
        this.initialId = this.props.value
        const results = await Promise.all([
            this.loadDataSource(),
            Helper.getTranslations(["WebSMS.ResourcePlanningScheduler.Flags.FlagIsDeleted"])
        ]);
        this.translations = results[1].Data;
        this.setState({})
    }

    private loadDataSource = async () => {
        const result = await HTTPService.noBusyIndicator().get<JsonResultClass>(`PlanningBoardFlag/GetAllFlags?includedId=${this.initialId}`);
        if (result.Code == 0) {
            this.dataSource = result.Data;
            this.canCreate = result.AdditionalData["canCreate"];
            this.canOpen = result.AdditionalData["canOpen"];

        } else {
            NotificationHelper.showErrorMessage(result.Message)
        }
    }

    private setValue = (value: string) => {
        this.setState({ value: value }, () => {
            this.props.onChange(this.props.field, value, this.dataSource.find(f => f.Id === value));
        })
    }

    private renderDropDown = () => {
        const props = this.factory.getDefaultDropDownProps();
        props.dataSource = JSON.parse(JSON.stringify(this.dataSource));
        props.value = this.state.value;
        props.field.dataTextField = "Name";
        props.field.dataValueField = "Id";
        props.disabled = this.props.disabled;
        props.field.refreshDSOnRefChange = true;
        props.field.template = "<table cellspacing='0' style='table-layout:fixed; width:150px;'><colgroup><col style='width: 150px' /></colgroup><tr><td style='vertical-align:top;'>${data.Name}</td></tr></table>";
        props.onChange = (_, value) => {
            if (Helper.isNullOrEmpty(value))
                value = null;
            this.setValue(value);
        }
        return (
            <div style={{ width: "100%", paddingTop: "1px" }}>
                <DropDownList {...props} />
            </div>
        );
    }

    private renderOpenButton = () => {
        const props: ButtonProps = {
            handleClick: () => {
                this.openSheet(this.state.value);
            },
            iconName: "pen",
            title: Config.translations.editLabel,
            buttonStyle: {
                borderLeft: "none",
                height: "40px"
            }
        }
        return (
            <>
                <Button {...props} />
            </>
        );
    }

    private renderCreateButton = () => {
        const props: ButtonProps = {
            handleClick: () => {
                this.openSheet();
            },
            iconName: "plus",
            title:  Config.translations.newLabel,
            buttonStyle: {
                marginLeft: "5px",
                borderRadius: this.showOpenButton() ? "var(--rounded-left)" : "var(--border-radius)",
                height: "40px"
            }
        }
        return (
            <>
                <Button {...props} />
            </>
        );
    }

    private openSheet = (id: string = null) => {
        const url = "PlanningBoardFlag/Edit" + (!Helper.isNullOrEmpty(id) ? `?id=${id}` : "");
        const sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.bind(SheetEventType.SavedSuccessfully, async (data) => {
            await this.loadDataSource();
            this.setState({}, () => {
                this.setValue(data.entity.Id);
            });
        })
    }
    private showOpenButton = () => {
        const buttonsEnabled = !Helper.hasValue(this.props.field.disableButtons) || !this.props.field.disableButtons;
        const selected = this.dataSource.find(f => f.Id == this.state.value);
        return this.canOpen && !this.props.disabled && Helper.hasValue(selected) && !selected.IsDeleted && buttonsEnabled;
    }

    render() {

        if (Config.settings.flagsAreActive && Helper.hasValue(this.dataSource)) {
            const buttonsEnabled = !Helper.hasValue(this.props.field.disableButtons) || !this.props.field.disableButtons;
            const selected = this.dataSource.find(f => f.Id == this.state.value);
            return (
                <div id="flag-selection">
                    <div style={{ display: "flex", justifyContent: "center", flexDirection: "row-reverse", marginBottom: "2px" }}>
                        {this.showOpenButton() ? this.renderOpenButton() : null}
                        {this.canCreate && !this.props.disabled && buttonsEnabled ? this.renderCreateButton() : null}
                        {this.renderDropDown()}
                    </div>
                    {
                        Helper.hasValue(selected) && selected.IsDeleted ? (
                            <label style={{ fontSize: "12px", color: "#d32f2f" }}>
                                {Helper.hasValue(this.translations) ? this.translations["WebSMS.ResourcePlanningScheduler.Flags.FlagIsDeleted"] : null}  
                            </label>
                        ) : <></>
                    }
                </div>
            ); 
        } else {
            return null;
        }
    }
}

interface FlagSelectionProps extends BaseComponentProps{
    value: string;
    field: FlagSelectionField; 
}

interface FlagSelectionField extends BaseField {
    disableButtons: boolean;
}

interface FlagSelectionState {
    value: string;
}

interface Flag {
    Id: string;
    Name: string;
    Color: string;
    FontColor: string;
    IsDeleted: boolean;
}